<div class="pdf-viewer-host">
  @if (!isLoaded()) {
    <div class="pdf-viewer-overlay">
      @if (progress() > 0 && progress() < 100) {
        <p-progressBar [value]="progress()" [style]="{ width: '16rem' }"></p-progressBar>
      } @else {
        <p-progressSpinner strokeWidth="4" [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
        <span class="pdf-viewer-overlay__label">Loading PDF…</span>
      }
    </div>
  }

  @if (error(); as message) {
    <div class="pdf-viewer-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ message }}</span>
      <p-button label="Retry" icon="pi pi-refresh" size="small" (onClick)="retry()" />
    </div>
  } @else if (showViewer()) {
    <ngx-extended-pdf-viewer
      [src]="src()"
      [height]="height()"
      [textLayer]="true"
      [showOpenFileButton]="false"
      [showPropertiesButton]="false"
      (progress)="onProgress($event)"
      (pdfLoaded)="isLoaded.set(true)"
      (pdfLoadingFailed)="onLoadError()"
    ></ngx-extended-pdf-viewer>
  }
</div>
